import React, {useEffect, useRef, useState} from "react";

function useInterval(callback: () => void, delay: number) {
    const callbacRef = useRef<() => void>();

    // update callback function with current render callback that has access to latest props and state
    useEffect(() => {
        callbacRef.current = callback;
    });

    useEffect(() => {
        if (!delay) {
            return () => {
            };
        }

        const interval = setInterval(() => {
            callbacRef.current && callbacRef.current();
        }, delay);
        return () => clearInterval(interval);
    }, [delay]);
}

type TimerProps = {
    origin: number,
    showHours: boolean
}

export default ({origin, showHours = true}: TimerProps) => {
    const [current, setCurrent] = useState(new Date().getTime())
    useInterval(() => {
        setCurrent(new Date().getTime())
    }, 1000)
    if (!origin) {
        return null;
    }

    let dif = Math.floor((current - origin) / 1000);
    const days = Math.floor(dif / 86400);
    dif = dif % 86400;
    const hours = Math.floor(dif / 3600);
    dif = dif % 3600;
    const minutes = Math.floor(dif / 60);
    const seconds = dif % 60


    return <span>{days > 0 && days + ":"}{(showHours || hours > 0) && hours}{(showHours || hours > 0) &&":"}{`0${minutes}`.slice(-2)}:{`0${seconds}`.slice(-2)}</span>

}
